<template class="bg-black min-h-screen w-full">
  <metainfo>
    <template v-slot:title="{ content }">{{ content ? `${content} | Nordstern` : `SITE_NAME` }}</template>
  </metainfo>
  <main class="bg-black min-h-screen w-full">
    <TopNavigation v-if="routeTopbarActive" />
    <router-view></router-view>
    <Notification />
    <Dialog />
  </main>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import TopNavigation from "./components/TopNavigation.vue";
import Notification from "./components/Notification.vue";
import Dialog from "./components/Dialog.vue";
import { useMeta } from "vue-meta";

const store = useStore();
const route = useRoute();

const routeTopbarActive = computed(() => route.meta.topbar);

useMeta({
  title: "Guestlist",
  htmlAttrs: { lang: "en", amp: true },
});

onMounted(() => {
  store.dispatch("initFirebase");
});
</script>